import '@tencent/exeditor3-ui-kit/dist/toolbar-select.js';
import { createIcon } from '@tencent/exeditor3-ui-kit/dist/icon.js';
export var MarginBlockDirection;
(function (MarginBlockDirection) {
    MarginBlockDirection["Top"] = "Top";
    MarginBlockDirection["Bottom"] = "Bottom";
})(MarginBlockDirection || (MarginBlockDirection = {}));
export class MarginBlockPlugin {
    constructor(opt) {
        this.name = 'marginBlock';
        this.renderToolbarItem = [
            {
                name: 'marginTop',
                label: '段前距',
                direction: MarginBlockDirection.Top,
            },
            {
                name: 'marginBottom',
                label: '段后距',
                direction: MarginBlockDirection.Bottom,
            },
        ].reduce((ret, toolbarItem) => ({
            ...ret,
            [toolbarItem.name]: () => {
                const select = document.createElement('exeditor-toolbar-select');
                Object.assign(select, {
                    label: this.editor.t(toolbarItem.label),
                }).appendChild(createIcon({
                    name: toolbarItem.name,
                    editor: this.editor,
                    fallback: () => import('./icon.js').then((m) => m[`${toolbarItem.name}Icon`]),
                }));
                this.opt.options.forEach((config) => {
                    const elt = document.createElement('exeditor-toolbar-option');
                    Object.assign(elt, {
                        slot: 'option',
                        value: config.value,
                        textContent: config.label,
                        onclick: () => {
                            this.editor.focus();
                            this.set(toolbarItem.direction, config.value);
                        },
                    });
                    select.appendChild(elt);
                });
                const setSelectProps = () => {
                    var _a;
                    select.value = (_a = this.get(toolbarItem.direction)) !== null && _a !== void 0 ? _a : '';
                    select.disabled = !this.canApply();
                };
                setSelectProps();
                this.editor.on('idlechange', setSelectProps);
                return select;
            },
        }), {});
        this.canApply = () => this.editor.selection().hasNode(this.opt.target);
        this.opt = {
            target: ['paragraph', 'heading'],
            options: [15, 20, 25].map((n) => ({ label: `${n}px`, value: `${n}px` })),
            ...opt,
        };
        this.specExtraAttrs = {
            marginTop: {
                target: this.opt.target,
                parse: (elt) => elt.style.marginTop,
                toDOMAttribute: (marginTop) => ({
                    style: marginTop ? `margin-top: ${marginTop}` : '',
                }),
            },
            marginBottom: {
                target: this.opt.target,
                parse: (elt) => elt.style.marginBottom,
                toDOMAttribute: (marginBottom) => ({
                    style: marginBottom ? `margin-bottom: ${marginBottom}` : '',
                }),
            },
        };
    }
    initEditor(editor) {
        this.editor = editor;
    }
    capabilities() {
        return {
            commands: {
                setTop: this.set.bind(this, MarginBlockDirection.Top),
                getTop: this.get.bind(this, MarginBlockDirection.Top),
                setBottom: this.set.bind(this, MarginBlockDirection.Bottom),
                getBottom: this.get.bind(this, MarginBlockDirection.Bottom),
            },
        };
    }
    set(direction, m) {
        const name = `margin${direction}`;
        this.editor.selection(true).updateNodeAttr(this.opt.target, name, m);
    }
    get(direction) {
        const name = `margin${direction}`;
        return this.editor.selection().getNodeAttr(this.opt.target, name);
    }
}
//# sourceMappingURL=index.js.map